<template>
  <ThreeColumn>
    <template v-slot:topLeft>

          <v-btn
            class="liiblack white--text" elevation="0" block
            to="/" 
            >
            <v-icon small class="mr-4">mdi-arrow-left</v-icon>
            {{$t('btntxt.back')}}{{$t('btntxt.ft_home')}}
          </v-btn>

    </template>

    <template v-slot:mainPanel>
      <v-row no-gutters :class="$vuetify.breakpoint.mdAndUp?'pr-6 d-flex fill-height align-center':''"  > 
        <v-col cols="12" class="mb-md-16">

          <h1 class="text-h1 heading404 font-italic font-weight-light mb-7">{{$t('error.page_unavailable')}}</h1>
          <h1 class="status404 font-weight-heavy mb-6 text-center">404</h1>

          <v-row no-gutters class="mt-8">
            <i18n path="error.error[0]" tag="p">
              <router-link :to="{name: 'feedback'}">{{$t('btntxt.contactus')}}</router-link>
            </i18n>
          </v-row>

          <!--search bar -->
          <v-row no-gutters class="mt-5">
            <v-col cols="12" sm="10">
              <v-text-field
                v-model="text"
                class="mb-0"
                :label="$i18n.t('btntxt.search')"
                  @click:append="go_search"
                  @keydown.enter="go_search"
                hide-no-data dense clearable filled solo outlined hide-details
                background-color="white"
                color="primary"
              >
              </v-text-field>
            </v-col>

            <v-col cols="12" sm="2">
              <v-btn block tile color="primary"  @click="go_search" height="40">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </v-row>

        </v-col>
      </v-row>
              
    </template>
  </ThreeColumn>
</template>

<script>
  import ThreeColumn from '@/components/applayout/ThreeColumn'
  export default {
    name: 'vpage-not-found',
    components: {
      ThreeColumn
    },
    data: () => ({
      text: ''
    }),
    /*watch: {
      '$i18n.locale': function(){
        window.document.title = `${this.$i18n.t('error.notfound')} | HKLII`
      }
    },*/
    methods: {
      go_search(){
        this.$router.push({name:'search-results', query:{q:this.text}})
      },
    },
    /*mounted(){
        window.document.title = `${this.$i18n.t('error.notfound')} | HKLII`
    }*/
    metaInfo(){
      return{
        title: this.$i18n.t('error.notfound'),
      }
    },
  }
</script>

<style scoped lang="scss">
  @import '@/sass/_typography.scss';

  p > a {
    @include link-no-underline;
  }

  .app-hklii.v-application .primary--text { 
    /*overwrite the active class color set in app.vue, for mobile nav*/
    color: var(--v-primary-base) !important;
  }

  .heading404{
    font-size: 3.2em !important;
    line-height: 1em;
  }

  .status404{
    font-size: 9em !important;
    font-family: 'Noto Serif Display';
    color: transparent;
    background: var(--v-liiblack-lighten2);
    -webkit-background-clip: text;
    -moz-background-clip: text;
    background-clip: text;
    text-shadow: 1px 1px 6px var(--v-rsidebg-base) ;
    letter-spacing: 0.1em;
  }

</style>